module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-Rear_2.6e042158.jpg";